module.exports = __webpack_public_path__ + "img/team-1.e67aaa5e.jpg";